import { Component, OnInit } from "@angular/core";
import { DashboardDisplayService } from "../dashboardDisplay/dashboardDisplay.service";
import { GroupingService } from "../grouping/grouping.service";
import { Router, ActivatedRoute } from "@angular/router";
import { KpiService } from "../kpi/kpi.service";
import { TIERS } from "../constants";

import * as _ from "lodash";
import { MetricConfigurationsConstants } from "./metric-configurations.constants";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "metric-configurations",
  templateUrl: "./metric-configurations.component.html",
  styleUrls: ["./metric-configurations.component.scss"],
})
export class MetricConfigurationsComponent implements OnInit {
  dataConfigs;
  selectedDataConfig;
  groupingTemplateId;
  isStarterUser: boolean;
  public MetricConfigurationsConstants = MetricConfigurationsConstants;
  public imagePath = "../assets/images/";

  constructor(
    private dashboardDisplayService: DashboardDisplayService,
    private groupingService: GroupingService,
    public router: Router,
    private route: ActivatedRoute,
    private kpiService: KpiService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.isStarterUser = data.sz_tier == TIERS.STARTER.key;
      },
      (error) => {
        console.error(error);
      }
    );
    if (!this.isStarterUser) {
      this.route.params.subscribe((params) => {
        this.groupingTemplateId = +params["id"]; // (+) converts string 'id' to a number

        if (!this.dataConfigs) {
          this.getDataConfigs();
        } else {
          this.getSelectedDataConfig();
        }
      });
    }
  }

  getSelectedDataConfig() {
    if (this.groupingTemplateId) {
      this.selectedDataConfig = _.filter(this.dataConfigs, [
        "groupingTemplateId",
        parseInt(this.groupingTemplateId),
      ])[0];
    } else {
      this.selectedDataConfig = this.dataConfigs[0];
    }
  }

  getDataConfigs() {
    this.dashboardDisplayService.getDataConfigs().subscribe(
      (data) => {
        this.dataConfigs = data;
        this.dataConfigs = _.sortBy(this.dataConfigs, ["displayName"]);
        this.groupingService.hideError();
        this.getSelectedDataConfig();
      },
      (error) => {
        this.dataConfigs = null;
        this.groupingService.showError();
        this.selectedDataConfig = null;
      }
    );
  }

  selectNewDataConfig(newDataConfig) {
    this.selectedDataConfig = newDataConfig;
    if (
      this.selectedDataConfig &&
      this.selectedDataConfig["groupingTemplateId"] != null
    ) {
      this.router.navigate([
        "/data-configuration/settings/configuration",
        this.selectedDataConfig.groupingTemplateId,
      ]);
    }
  }
}
